import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { formatWhatsNewDate, whatsNewDetailPath } from "./whatsNewApi";
import styles from "./whatsNew.module.scss";

const WhatsNewDrawer = ({
  entries = [],
  onOpenEntry,
  onMarkAll,
  onSeeAll,
  canEdit,
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.drawer} data-testid="whats-new-drawer">
      <div className={styles.drawerHeader}>
        <div>
          <h2 className={styles.drawerTitle}>{t("whats_new.title")}</h2>
          <p className={styles.drawerSub}>{t("whats_new.subtitle")}</p>
        </div>
        {entries.some((item) => !item.is_read) ? (
          <button type="button" className={styles.headerBtn} onClick={onMarkAll}>
            {t("whats_new.markAll")}
          </button>
        ) : null}
      </div>
      {entries.length === 0 ? (
        <div className={styles.empty}>{t("whats_new.empty")}</div>
      ) : (
        entries.map((item) => (
          <button
            type="button"
            key={item.id}
            className={styles.item}
            onClick={() => onOpenEntry(item)}
          >
            {item.hero_image_url ? (
              <img className={styles.thumb} src={item.hero_image_url} alt="" />
            ) : (
              <span className={styles.thumb} />
            )}
            <span>
              <p className={styles.itemTitle}>{item.title}</p>
              <p className={styles.itemMeta}>
                {formatWhatsNewDate(item.published_at, i18n.language)}
                {item.summary ? ` · ${item.summary}` : ""}
              </p>
            </span>
            {item.is_read ? null : <span className={styles.unreadDot} />}
          </button>
        ))
      )}
      <div className={styles.drawerFooter}>
        <button type="button" className={styles.headerBtn} onClick={onSeeAll}>
          {t("whats_new.seeAll")}
        </button>
        {canEdit ? (
          <button
            type="button"
            className={styles.headerBtn}
            onClick={() => history.push("/console/ops/whats-new-cms")}
          >
            {t("whats_new.cms")}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default WhatsNewDrawer;
